module.exports = __webpack_public_path__ + "media/ingredients-cube-large.c7e0180e.mp4";